<template>
  <div>
    <SectionTitle :label="$t('label.privacyPolicy')" text-class="primary--text text--darken-1" />
    <div v-html="personalDataPolicy" class="scrollable-text-section" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SectionTitle from '@/components/SectionTitle.vue'
export default {
  name: 'PrivacyPolicy',

  components: { SectionTitle },

  computed: {
    ...mapGetters('page', ['personalDataPolicy'])
  }
}
</script>
